import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ArticleSingleView from './ArticleSingleView';
import ArticlesTable from './ArticlesTable';
import PreviousPageLink from '../PreviousPageLink/PreviousPageLink';
import FiltersPanel from '../Filters/FiltersPanel';
import headerActions, { UPDATE_HELP_URL } from '../Header/Header.actions';
import ArticlesListingTable from './ArticlesListingTable';
import { FormattedMessage } from 'react-intl';

class ArticleListing extends Component {
    static propTypes = {
        url: PropTypes.string,
        countUrl: PropTypes.string,
        urlParams: PropTypes.object,
        helpUrl: PropTypes.string,
        filters: PropTypes.object,
        showArticle: PropTypes.func
    };

    static defaultProps = {
        helpUrl: 'home?lbu=US&locale=en_US&audience=all',
        showArticle: null
    };

    constructor(props) {
        super(props);

        this.state = {
            lastTimestamp: null,
            lastPosition: 0,
            articleViewData: null
        };

        this.closeArticleView = this.closeArticleView.bind(this);
        this.showArticleView = this.showArticleView.bind(this);
    }

    showArticleView (article, articleIndex) {
        if (this.props.showArticle) {
            return this.props.showArticle(article, articleIndex);
        } else {
            const { url, countUrl, urlParams } = this.props;
            headerActions.updateHelpUrl('viewingnewsarticlestips-field?lbu=US&locale=en_US&audience=all');
            this.setState({
                lastPosition: window.pageYOffset || document.documentElement.scrollTop,
                articleViewData: {
                    articleId: article.articleId, articleIndex, url, countUrl, urlParams
                }
            });
        }
    };

    closeArticleView() {
        headerActions.updateHelpUrl(this.props.helpUrl); //reset the help url to the parent's help url
        this.setState({
            articleViewData: null
        });
        setTimeout(() => {
            window.scrollTo(0, this.state.lastPosition);
        }, 10);

    };

    getBackLocation() {
        let location = "/start"
        if (window.location.href.indexOf('?backRoute=') > -1) {
            location =  window.location.href.substr(window.location.href.indexOf('?backRoute=') + 11);
        }
        return location
    }

    render() {
        return (
            <div className='article-listing'>
                {!this.state.articleViewData && <div className='page-filters-container'>
                    <FiltersPanel urlParams={this.props.urlParams}/>
                </div> }
                <div className={"listing-page " + (this.state.articleViewData ? "hidden" : "")}>
                    <PreviousPageLink
                        location={this.getBackLocation()}
                        text="General_CoreFunctionality_UIText_general.backToPreviousPage" />
                    { this.props.children }
                    {/*<ArticlesTable
                        url={this.props.url}
                        countUrl={this.props.countUrl}
                        urlParams={this.props.urlParams}
                        showArticleView={this.showArticleView}/>*/}


                    <ArticlesListingTable api={this.props.api}
                                          filters={{
                                              ...this.props.filters,
                                              payload: this.props.urlParams
                                          }}
                                          onClickArticle={this.showArticleView} />
                </div>
                {this.state.articleViewData &&
                    <ArticleSingleView
                        articleId={this.state.articleViewData.articleId}
                        articleIndex={this.state.articleViewData.articleIndex}
                        url={this.state.articleViewData.url}
                        countUrl={this.state.articleViewData.countUrl}
                        urlParams={this.state.articleViewData.urlParams}
                        closeArticleView={this.closeArticleView}
                    />
                }
            </div>
        );
    }
}

export default ArticleListing;


// WEBPACK FOOTER //
// ./src/scripts/reusable/Articles/ArticleListing.jsx